import { render } from "./InvitePeople.vue?vue&type=template&id=1aea083a&scoped=true&ts=true&lang=pug"
import script from "./InvitePeople.vue?vue&type=script&lang=ts"
export * from "./InvitePeople.vue?vue&type=script&lang=ts"

import "./InvitePeople.vue?vue&type=style&index=0&id=1aea083a&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aea083a"]])

export default __exports__